import { Component } from "react";
import LoadingCard from "shared/ui/LoadingCard";

function isChunkError(error) {
    return (
        error?.message?.includes("Loading chunk") ||
        error?.message?.includes("Loading CSS chunk") ||
        error?.name === "ChunkLoadError"
    );
}

export default class ChunkErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, isChunk: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, isChunk: isChunkError(error) };
    }

    componentDidCatch(error) {
        if (isChunkError(error)) {
            window.location.reload();
        }
    }

    render() {
        if (this.state.hasError) {
            if (this.state.isChunk) {
                return <LoadingCard fullScreen />;
            }

            return (
                <div className="min-h-screen flex flex-col items-center justify-center gap-4">
                    <p className="text-sm text-gray-500">
                        Algo deu errado. Tente recarregar a página.
                    </p>
                    <button
                        className="text-sm underline"
                        onClick={() => window.location.reload()}
                    >
                        Recarregar
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}
